exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container--2pydm{display:flex;align-items:center;justify-content:center;position:absolute;width:30px;height:30px;right:16px;top:16px;z-index:450;border-top-right-radius:4px;border-top-left-radius:4px;background:#fff;box-shadow:0 8px 16px rgba(101,115,129,.24);border-bottom:1px solid #e0e0e0;cursor:pointer;font-size:15px}@media(max-width:1023px){.container--2pydm{display:none}}", ""]);

// Exports
exports.locals = {
	"container": "container--2pydm"
};